import script from "./AgeVerification.vue?vue&type=script&setup=true&lang=js"
export * from "./AgeVerification.vue?vue&type=script&setup=true&lang=js"

import "./AgeVerification.vue?vue&type=style&index=0&id=59756a78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59756a78"]])

export default __exports__